import * as React from "react";
import styles from './Animation.module.scss'
import {Animation} from "@mui/icons-material";
import {SvgIconProps} from "@mui/material";

interface MyIconProps {
    customVariant?: 'primary' | 'secondary' | 'inherit'
}

function AnimationIcon({customVariant = 'inherit', ...props}:  SvgIconProps & MyIconProps) {
    return (
        <div className={customVariant !== 'inherit' && styles.circle}>
            <Animation {...props}  className={styles[customVariant] || ''} />
        </div>

    );
}

export default AnimationIcon;
